var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-records"},[_vm._v(" Showing "),_c('span',{staticClass:"table-records__count"},[_vm._v(_vm._s(_vm.returnEnd() > 0 ? _vm.returnStart() : 0)+" - "+_vm._s(_vm.returnEnd()))]),_vm._v(" of "),_c('span',{staticClass:"table-records__count"},[_vm._v(_vm._s(_vm.all))]),_vm._v(" records ")])
}
var staticRenderFns = []

export { render, staticRenderFns }